/**
 * @file Web Gallery Account related fragments.
 */

import gql from 'graphql-tag';

import { AlbumRootAlbumFolderBaseDetails } from '../../../../graphql/fragments/album';
import { WatermarkConfigDetails } from '../../../../graphql/fragments/account';

export const WebGalleryAccountDetailsWithImageAssets = gql`
  fragment WebGalleryAccountDetailsWithImageAssets on Account {
    id
    name
    username
    email_address
    email_verified
    phone_number
    organization_name
    slug
    logo_image {
      id
      url
    }
    hero_image {
      id
      url
    }
    avatar_photo {
      id
      thumbnail_urls {
        size_code
        url
      }
    }
    pro_settings {
      multi_pose_print_packages_enabled
      multi_identity_print_packages_enabled
      multi_identity_digital_bundles_enabled
      ...WatermarkConfigDetails
    }
  }
  ${WatermarkConfigDetails}
`;

export const WebGalleryHierarchyItemFields = gql`
  fragment HierarchyItemFields on IHierarchyItem {
    ... on IHierarchyItem {
      id
      item_type
    }
    ... on HierarchyAlbumFolderItem {
      albums {
        total
      }
      album_folder {
        id
        name
        has_password
        start_date
        end_date
        description
        album_type
        album_subtype
        cover_photos(slice: { limit: 1 }) {
          records {
            id
            faces_box
            thumbnail_urls {
              size_code
              url
            }
          }
        }
        is_web_gallery
        all_photos_mode
        join_code
        public_join_code_verification_enabled
        picture_day_enabled
        auto_contributor_settings {
          upload_access
        }
        joins_enabled
      }
    }
    ... on HierarchyAlbumItem {
      album {
        id
        name
        has_password
        start_date
        end_date
        album_type
        album_subtype
        cover_photo {
          id
          faces_box
          thumbnail_urls {
            size_code
            url
          }
        }
        description
        is_web_gallery
        join_code
        public_join_code_verification_enabled
        ...AlbumRootAlbumFolderBaseDetails
        auto_contributor_settings {
          upload_access
        }
        joins_enabled
        root_album_folder {
          id
          join_code
        }
      }
    }
  }
  ${AlbumRootAlbumFolderBaseDetails}
`;
